// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Numeral = require("../../utils/Numeral.bs.js");
var V4 = require("uuid/v4");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Core__Int = require("@rescript/core/src/Core__Int.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MediaQuery = require("../../reason/common/Media/MediaQuery.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Switch = require("../../uikit/reason/atoms/Form/Form__Switch.bs.js");
var RescriptCore = require("@rescript/core/src/RescriptCore.bs.js");
var TogglesGroup = require("../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
var ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
var Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
var Form__Checkbox = require("../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
var Form__Validators2 = require("../../reason/common/Form/Form__Validators2.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
var NotificationSettingsPreferenceEditDialogAreaGroups = require("./NotificationSettingsPreferenceEditDialogAreaGroups.bs.js");
var NotificationSettingsPreferenceEditDialog_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_chapter_graphql.bs.js");
var NotificationSettingsPreferenceEditDialog_settings_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_settings_graphql.bs.js");
var NotificationSettingsPreferenceEditDialog_areaGroup_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_areaGroup_graphql.bs.js");
var NotificationSettingsPreferenceEditDialog_clientNeed_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_clientNeed_graphql.bs.js");
var NotificationSettingsPreferenceEditDialog_preference_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_preference_graphql.bs.js");
var NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.bs.js");

function NotificationSettingsPreferenceEditDialog$CheckSection(props) {
  var helpText = props.helpText;
  var renderWhenClosed = props.renderWhenClosed;
  var isOpen = props.isOpen;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("label", {
                            children: [
                              JsxRuntime.jsx(Form__Switch.make, {
                                    on: isOpen,
                                    onToggle: props.onUpdate
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: props.title,
                                    className: "ml-2 font-semibold text-lg"
                                  })
                            ],
                            className: "flex flex-row items-center text-gray-800"
                          })
                    }),
                isOpen ? JsxRuntime.jsxs("div", {
                        children: [
                          helpText !== undefined ? JsxRuntime.jsx("div", {
                                  children: helpText,
                                  className: "text-gray-500 italic leading-6"
                                }) : null,
                          props.children
                        ],
                        className: "mt-2 px-2"
                      }) : (
                    renderWhenClosed !== undefined ? JsxRuntime.jsx("div", {
                            children: Caml_option.valFromOption(renderWhenClosed),
                            className: "mt-2 px-2"
                          }) : null
                  )
              ],
              className: "p-4"
            });
}

var CheckSection = {
  make: NotificationSettingsPreferenceEditDialog$CheckSection
};

function NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog(props) {
  var onDiscardChanges = props.onDiscardChanges;
  var onKeepChanges = props.onKeepChanges;
  return JsxRuntime.jsx(ConfirmDialog.make, {
              title: "Discard Your Changes?",
              ariaLabel: "Discard Your Changes?",
              body: JsxRuntime.jsx("div", {
                    children: "Do you wish to discard the changes you've made?"
                  }),
              isOpen: props.isOpen,
              onCancel: onKeepChanges,
              cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        onKeepChanges();
                      }),
                    children: "Keep Editing"
                  }),
              confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
                    onClick: (function (param) {
                        onDiscardChanges();
                      }),
                    children: "Discard Changes"
                  })
            });
}

var ConfirmDiscardChangesDialog = {
  make: NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog
};

var validators_minPriceToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      return {
              TAG: "Ok",
              _0: param.minPriceToggle
            };
    })
};

var validators_minPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (state, param) {
      if (!state.minPriceToggle) {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var tanType = param.tanType;
      var validated = Form__Validators2.chain(state, [
            (function (param) {
                return Form__Validators2.isNotNone(param.minPrice);
              }),
            (function (param) {
                return Form__Validators2.validateIfNotNone(param.minPrice, (function (extra) {
                              return Form__Validators2.isMoreThan(true, tanType === "RENTAL" ? 750 : 50000, extra);
                            }));
              }),
            (function (param) {
                return Form__Validators2.validateIfNotNone(param.minPrice, (function (extra) {
                              return Form__Validators2.isLessThan(true, 250000000, extra);
                            }));
              }),
            (function (param) {
                var maxPrice = param.maxPrice;
                var minPrice = param.minPrice;
                if (minPrice !== undefined && maxPrice !== undefined) {
                  if (maxPrice > minPrice) {
                    return {
                            TAG: "Ok",
                            _0: minPrice
                          };
                  } else {
                    return {
                            TAG: "Error",
                            _0: "must be less than the maximum price"
                          };
                  }
                } else {
                  return {
                          TAG: "Ok",
                          _0: minPrice
                        };
                }
              })
          ]);
      if (validated.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: validated._0.minPrice
              };
      } else {
        return {
                TAG: "Error",
                _0: validated._0
              };
      }
    })
};

var validators_maxPriceToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      return {
              TAG: "Ok",
              _0: param.maxPriceToggle
            };
    })
};

var validators_maxPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (state, param) {
      if (!state.maxPriceToggle) {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var tanType = param.tanType;
      var validated = Form__Validators2.chain(state, [
            (function (param) {
                return Form__Validators2.isNotNone(param.maxPrice);
              }),
            (function (param) {
                return Form__Validators2.validateIfNotNone(param.maxPrice, (function (extra) {
                              return Form__Validators2.isMoreThan(true, tanType === "RENTAL" ? 1000 : 100000, extra);
                            }));
              }),
            (function (param) {
                return Form__Validators2.validateIfNotNone(param.maxPrice, (function (extra) {
                              return Form__Validators2.isLessThan(true, 250000000, extra);
                            }));
              }),
            (function (param) {
                var maxPrice = param.maxPrice;
                var minPrice = param.minPrice;
                if (minPrice !== undefined && maxPrice !== undefined) {
                  if (maxPrice > minPrice) {
                    return {
                            TAG: "Ok",
                            _0: maxPrice
                          };
                  } else {
                    return {
                            TAG: "Error",
                            _0: "must be more than the minimum price"
                          };
                  }
                } else {
                  return {
                          TAG: "Ok",
                          _0: maxPrice
                        };
                }
              })
          ]);
      if (validated.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: validated._0.maxPrice
              };
      } else {
        return {
                TAG: "Error",
                _0: validated._0
              };
      }
    })
};

var validators_propertyTypesToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      return {
              TAG: "Ok",
              _0: param.propertyTypesToggle
            };
    })
};

var validators_propertyTypes = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var propertyTypes = param.propertyTypes;
      if (param.propertyTypesToggle) {
        if (propertyTypes.length !== 0) {
          return {
                  TAG: "Ok",
                  _0: propertyTypes
                };
        } else {
          return {
                  TAG: "Error",
                  _0: "You must select at least one property type"
                };
        }
      } else {
        return {
                TAG: "Ok",
                _0: []
              };
      }
    })
};

var validators_mlsStatus = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      return {
              TAG: "Ok",
              _0: param.mlsStatus
            };
    })
};

var validators_areaGroup = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param, param$1) {
      var areaGroup = param.areaGroup;
      var areas;
      switch (areaGroup.TAG) {
        case "UserAreaGroup" :
            areas = areaGroup.areas;
            break;
        case "ChapterAreaGroup" :
            return {
                    TAG: "Ok",
                    _0: areaGroup
                  };
        case "NewAreaGroup" :
            areas = areaGroup.areas;
            break;
        
      }
      if (areas.length > 0) {
        return {
                TAG: "Ok",
                _0: areaGroup
              };
      } else {
        return {
                TAG: "Error",
                _0: "You must select at least one area"
              };
      }
    })
};

var validators = {
  minPriceToggle: validators_minPriceToggle,
  minPrice: validators_minPrice,
  maxPriceToggle: validators_maxPriceToggle,
  maxPrice: validators_maxPrice,
  propertyTypesToggle: validators_propertyTypesToggle,
  propertyTypes: validators_propertyTypes,
  mlsStatus: validators_mlsStatus,
  areaGroup: validators_areaGroup
};

function initialFieldsStatuses(_input) {
  return {
          minPriceToggle: "Pristine",
          minPrice: "Pristine",
          maxPriceToggle: "Pristine",
          maxPrice: "Pristine",
          propertyTypesToggle: "Pristine",
          propertyTypes: "Pristine",
          mlsStatus: "Pristine",
          areaGroup: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.minPriceToggle;
  var tmp;
  tmp = typeof match !== "object" ? validators.minPriceToggle.validate(input, metadata) : match._0;
  var match$1 = fieldsStatuses.minPrice;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.minPrice.validate(input, metadata) : match$1._0;
  var match$2 = fieldsStatuses.maxPriceToggle;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.maxPriceToggle.validate(input, metadata) : match$2._0;
  var match$3 = fieldsStatuses.maxPrice;
  var tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.maxPrice.validate(input, metadata) : match$3._0;
  var match$4 = fieldsStatuses.propertyTypesToggle;
  var tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.propertyTypesToggle.validate(input, metadata) : match$4._0;
  var match$5 = fieldsStatuses.propertyTypes;
  var tmp$5;
  tmp$5 = typeof match$5 !== "object" ? validators.propertyTypes.validate(input, metadata) : match$5._0;
  var match$6 = fieldsStatuses.mlsStatus;
  var tmp$6;
  tmp$6 = typeof match$6 !== "object" ? validators.mlsStatus.validate(input, metadata) : match$6._0;
  var match$7 = fieldsStatuses.areaGroup;
  var tmp$7;
  tmp$7 = typeof match$7 !== "object" ? validators.areaGroup.validate(input, metadata) : match$7._0;
  var minPriceToggleResult = tmp;
  var minPriceToggleResult$1;
  if (minPriceToggleResult.TAG === "Ok") {
    var minPriceResult = tmp$1;
    if (minPriceResult.TAG === "Ok") {
      var maxPriceToggleResult = tmp$2;
      if (maxPriceToggleResult.TAG === "Ok") {
        var maxPriceResult = tmp$3;
        if (maxPriceResult.TAG === "Ok") {
          var propertyTypesToggleResult = tmp$4;
          if (propertyTypesToggleResult.TAG === "Ok") {
            var propertyTypesResult = tmp$5;
            if (propertyTypesResult.TAG === "Ok") {
              var mlsStatusResult = tmp$6;
              if (mlsStatusResult.TAG === "Ok") {
                var areaGroupResult = tmp$7;
                if (areaGroupResult.TAG === "Ok") {
                  return {
                          TAG: "Valid",
                          output: {
                            minPriceToggle: minPriceToggleResult._0,
                            minPrice: minPriceResult._0,
                            maxPriceToggle: maxPriceToggleResult._0,
                            maxPrice: maxPriceResult._0,
                            propertyTypesToggle: propertyTypesToggleResult._0,
                            propertyTypes: propertyTypesResult._0,
                            mlsStatus: mlsStatusResult._0,
                            areaGroup: areaGroupResult._0
                          },
                          fieldsStatuses: {
                            minPriceToggle: {
                              TAG: "Dirty",
                              _0: minPriceToggleResult,
                              _1: "Shown"
                            },
                            minPrice: {
                              TAG: "Dirty",
                              _0: minPriceResult,
                              _1: "Shown"
                            },
                            maxPriceToggle: {
                              TAG: "Dirty",
                              _0: maxPriceToggleResult,
                              _1: "Shown"
                            },
                            maxPrice: {
                              TAG: "Dirty",
                              _0: maxPriceResult,
                              _1: "Shown"
                            },
                            propertyTypesToggle: {
                              TAG: "Dirty",
                              _0: propertyTypesToggleResult,
                              _1: "Shown"
                            },
                            propertyTypes: {
                              TAG: "Dirty",
                              _0: propertyTypesResult,
                              _1: "Shown"
                            },
                            mlsStatus: {
                              TAG: "Dirty",
                              _0: mlsStatusResult,
                              _1: "Shown"
                            },
                            areaGroup: {
                              TAG: "Dirty",
                              _0: areaGroupResult,
                              _1: "Shown"
                            }
                          },
                          collectionsStatuses: undefined
                        };
                }
                minPriceToggleResult$1 = minPriceToggleResult;
              } else {
                minPriceToggleResult$1 = minPriceToggleResult;
              }
            } else {
              minPriceToggleResult$1 = minPriceToggleResult;
            }
          } else {
            minPriceToggleResult$1 = minPriceToggleResult;
          }
        } else {
          minPriceToggleResult$1 = minPriceToggleResult;
        }
      } else {
        minPriceToggleResult$1 = minPriceToggleResult;
      }
    } else {
      minPriceToggleResult$1 = minPriceToggleResult;
    }
  } else {
    minPriceToggleResult$1 = minPriceToggleResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            minPriceToggle: {
              TAG: "Dirty",
              _0: minPriceToggleResult$1,
              _1: "Shown"
            },
            minPrice: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            maxPriceToggle: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            },
            maxPrice: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            },
            propertyTypesToggle: {
              TAG: "Dirty",
              _0: tmp$4,
              _1: "Shown"
            },
            propertyTypes: {
              TAG: "Dirty",
              _0: tmp$5,
              _1: "Shown"
            },
            mlsStatus: {
              TAG: "Dirty",
              _0: tmp$6,
              _1: "Shown"
            },
            areaGroup: {
              TAG: "Dirty",
              _0: tmp$7,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurMinPriceToggleField" :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.minPriceToggle, validators_minPriceToggle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: status,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurMinPriceField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.minPrice, validators_minPrice, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: status,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurMaxPriceToggleField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.maxPriceToggle, validators_maxPriceToggle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: status,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurMaxPriceField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.maxPrice, validators_maxPrice, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: status,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurPropertyTypesToggleField" :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.propertyTypesToggle, validators_propertyTypesToggle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: status,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurPropertyTypesField" :
                  var result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.propertyTypes, validators_propertyTypes, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: status,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurMlsStatusField" :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.mlsStatus, validators_mlsStatus, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: status,
                                  areaGroup: init.areaGroup
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurAreaGroupField" :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.areaGroup, validators_areaGroup, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  minPriceToggle: init.minPriceToggle,
                                  minPrice: init.minPrice,
                                  maxPriceToggle: init.maxPriceToggle,
                                  maxPrice: init.maxPrice,
                                  propertyTypesToggle: init.propertyTypesToggle,
                                  propertyTypes: init.propertyTypes,
                                  mlsStatus: init.mlsStatus,
                                  areaGroup: status
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateMinPriceToggleField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.minPriceToggle, state.submissionStatus, validators_minPriceToggle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: status,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateMinPriceField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.minPrice, state.submissionStatus, validators_minPrice, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: status,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateMaxPriceToggleField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.maxPriceToggle, state.submissionStatus, validators_maxPriceToggle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: status,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateMaxPriceField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.maxPrice, state.submissionStatus, validators_maxPrice, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: status,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdatePropertyTypesToggleField" :
                  var nextInput$4 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.propertyTypesToggle, state.submissionStatus, validators_propertyTypesToggle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: status,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdatePropertyTypesField" :
                  var nextInput$5 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.propertyTypes, state.submissionStatus, validators_propertyTypes, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: status,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateMlsStatusField" :
                  var nextInput$6 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.mlsStatus, state.submissionStatus, validators_mlsStatus, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: status,
                                            areaGroup: init.areaGroup
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateAreaGroupField" :
                  var nextInput$7 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.areaGroup, state.submissionStatus, validators_areaGroup, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            minPriceToggle: init.minPriceToggle,
                                            minPrice: init.minPrice,
                                            maxPriceToggle: init.maxPriceToggle,
                                            maxPrice: init.maxPrice,
                                            propertyTypesToggle: init.propertyTypesToggle,
                                            propertyTypes: init.propertyTypes,
                                            mlsStatus: init.mlsStatus,
                                            areaGroup: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateMinPriceToggle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateMinPriceToggleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateMinPrice: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateMinPriceField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateMaxPriceToggle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateMaxPriceToggleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateMaxPrice: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateMaxPriceField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updatePropertyTypesToggle: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdatePropertyTypesToggleField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updatePropertyTypes: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdatePropertyTypesField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateMlsStatus: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateMlsStatusField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateAreaGroup: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateAreaGroupField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurMinPriceToggle: (function () {
              dispatch("BlurMinPriceToggleField");
            }),
          blurMinPrice: (function () {
              dispatch("BlurMinPriceField");
            }),
          blurMaxPriceToggle: (function () {
              dispatch("BlurMaxPriceToggleField");
            }),
          blurMaxPrice: (function () {
              dispatch("BlurMaxPriceField");
            }),
          blurPropertyTypesToggle: (function () {
              dispatch("BlurPropertyTypesToggleField");
            }),
          blurPropertyTypes: (function () {
              dispatch("BlurPropertyTypesField");
            }),
          blurMlsStatus: (function () {
              dispatch("BlurMlsStatusField");
            }),
          blurAreaGroup: (function () {
              dispatch("BlurAreaGroupField");
            }),
          minPriceToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.minPriceToggle),
          minPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.minPrice),
          maxPriceToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.maxPriceToggle),
          maxPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.maxPrice),
          propertyTypesToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.propertyTypesToggle),
          propertyTypesResult: Formality.exposeFieldResult(state.fieldsStatuses.propertyTypes),
          mlsStatusResult: Formality.exposeFieldResult(state.fieldsStatuses.mlsStatus),
          areaGroupResult: Formality.exposeFieldResult(state.fieldsStatuses.areaGroup),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.minPriceToggle;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.minPrice;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.maxPriceToggle;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.maxPrice;
              if (typeof tmp$3 === "object") {
                return true;
              }
              var tmp$4 = match.propertyTypesToggle;
              if (typeof tmp$4 === "object") {
                return true;
              }
              var tmp$5 = match.propertyTypes;
              if (typeof tmp$5 === "object") {
                return true;
              }
              var tmp$6 = match.mlsStatus;
              if (typeof tmp$6 === "object") {
                return true;
              }
              var tmp$7 = match.areaGroup;
              if (typeof tmp$7 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertVariables = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertVariables;

var convertResponse = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

var UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

var UpdateUserNotificationPreferenceV5Mutation = {
  forSalePropertyTypeEnumV5_decode: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

var forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

var convertFragment = NotificationSettingsPreferenceEditDialog_preference_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

var PreferenceFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var PreferenceFragment_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

var PreferenceFragment = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: PreferenceFragment_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: PreferenceFragment_propertyNotificationPreferenceMLSStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

var ClientNeedFragment_forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var ClientNeedFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var ClientNeedFragment = {
  forSalePropertyTypeEnumV5_decode: ClientNeedFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ClientNeedFragment_forSalePropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var areaTypeV5_decode = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.areaTypeV5_decode;

var matchableEntityType_decode = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.matchableEntityType_decode;

var convertFragment$2 = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

var AreaGroupFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.areaTypeV5_fromString;

var AreaGroupFragment_matchableEntityType_fromString = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.matchableEntityType_fromString;

var AreaGroupFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: AreaGroupFragment_areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: AreaGroupFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

var convertFragment$3 = NotificationSettingsPreferenceEditDialog_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$4,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

var convertFragment$4 = NotificationSettingsPreferenceEditDialog_settings_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

var SettingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$5,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function NotificationSettingsPreferenceEditDialog(props) {
  var onClose = props.onClose;
  var entityType = props.entityType;
  var settings = use$5(props.settings);
  var match = use();
  var updatePreference = match[0];
  var chapter = use$4(props.chapter);
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var handleFailure = function () {
    addMessage(SystemMessages.Message.make(V4(), "error", "There was an error updating your preferences", 5000, undefined, undefined));
  };
  var handleSuccess = function () {
    addMessage(SystemMessages.Message.make(V4(), "info", "Updated notification settings", 5000, undefined, undefined));
  };
  var tmp;
  if (typeof entityType === "object") {
    var variant = entityType.NAME;
    if (variant === "RENTAL_PROPERTY" || variant === "FOR_SALE_PROPERTY") {
      var fragmentRefs = entityType.VAL;
      tmp = fragmentRefs !== undefined ? Caml_option.some(Caml_option.valFromOption(fragmentRefs)) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  var propertyPreference = useOpt(tmp);
  var tmp$1;
  if (typeof entityType === "object") {
    var variant$1 = entityType.NAME;
    if (variant$1 === "RENTAL_NEED" || variant$1 === "BUYER_NEED") {
      var fragmentRefs$1 = entityType.VAL;
      tmp$1 = fragmentRefs$1 !== undefined ? Caml_option.some(Caml_option.valFromOption(fragmentRefs$1)) : undefined;
    } else {
      tmp$1 = undefined;
    }
  } else {
    tmp$1 = undefined;
  }
  var clientNeedPreference = useOpt$1(tmp$1);
  var preference;
  if (typeof entityType === "object") {
    var variant$2 = entityType.NAME;
    preference = variant$2 === "BUYER_NEED" ? ({
          NAME: "BUYER_NEED",
          VAL: clientNeedPreference
        }) : (
        variant$2 === "FOR_SALE_PROPERTY" ? ({
              NAME: "FOR_SALE_PROPERTY",
              VAL: propertyPreference
            }) : (
            variant$2 === "RENTAL_NEED" ? ({
                  NAME: "RENTAL_NEED",
                  VAL: clientNeedPreference
                }) : (
                variant$2 === "RENTAL_PROPERTY" ? ({
                      NAME: "RENTAL_PROPERTY",
                      VAL: propertyPreference
                    }) : RescriptCore.panic("Entity type did not match. This should not happen.")
              )
          )
      );
  } else {
    preference = RescriptCore.panic("Entity type did not match. This should not happen.");
  }
  var variant$3 = preference.NAME;
  var preferenceType = variant$3 === "FOR_SALE_PROPERTY" ? "FOR_SALE_PROPERTY" : (
      variant$3 === "RENTAL_NEED" ? "RENTAL_NEED" : (
          variant$3 === "RENTAL_PROPERTY" ? "RENTAL_PROPERTY" : "BUYER_NEED"
        )
    );
  var match$2 = chapter.notificationPreferences;
  var tmp$2;
  switch (preferenceType) {
    case "BUYER_NEED" :
        tmp$2 = match$2 !== undefined ? match$2.buyerNeeds.areaGroup.fragmentRefs : RescriptCore.panic("Did not find expected chapter area group.");
        break;
    case "FOR_SALE_PROPERTY" :
        tmp$2 = match$2 !== undefined ? match$2.forSaleProperties.areaGroup.fragmentRefs : RescriptCore.panic("Did not find expected chapter area group.");
        break;
    case "RENTAL_NEED" :
        tmp$2 = match$2 !== undefined ? match$2.rentalNeeds.areaGroup.fragmentRefs : RescriptCore.panic("Did not find expected chapter area group.");
        break;
    case "RENTAL_PROPERTY" :
        tmp$2 = match$2 !== undefined ? match$2.rentalProperties.areaGroup.fragmentRefs : RescriptCore.panic("Did not find expected chapter area group.");
        break;
    
  }
  var chapterDefaultAreaGroup = use$3(tmp$2);
  var tmp$3;
  if (typeof preference === "object") {
    var variant$4 = preference.NAME;
    if (variant$4 === "BUYER_NEED") {
      var match$3 = preference.VAL;
      if (match$3 !== undefined) {
        var match$4 = match$3.areaGroup;
        tmp$3 = match$4 !== undefined ? Caml_option.some(match$4.fragmentRefs) : undefined;
      } else {
        tmp$3 = undefined;
      }
    } else if (variant$4 === "FOR_SALE_PROPERTY") {
      var match$5 = preference.VAL;
      if (match$5 !== undefined) {
        var match$6 = match$5.areaGroup;
        tmp$3 = match$6 !== undefined ? Caml_option.some(match$6.fragmentRefs) : undefined;
      } else {
        tmp$3 = undefined;
      }
    } else if (variant$4 === "RENTAL_NEED") {
      var match$7 = preference.VAL;
      if (match$7 !== undefined) {
        var match$8 = match$7.areaGroup;
        tmp$3 = match$8 !== undefined ? Caml_option.some(match$8.fragmentRefs) : undefined;
      } else {
        tmp$3 = undefined;
      }
    } else if (variant$4 === "RENTAL_PROPERTY") {
      var match$9 = preference.VAL;
      if (match$9 !== undefined) {
        var match$10 = match$9.areaGroup;
        tmp$3 = match$10 !== undefined ? Caml_option.some(match$10.fragmentRefs) : undefined;
      } else {
        tmp$3 = undefined;
      }
    } else {
      tmp$3 = undefined;
    }
  } else {
    tmp$3 = undefined;
  }
  var currentAreaGroup = useOpt$2(tmp$3);
  var variant$5 = preference.NAME;
  var tanType = variant$5 === "RENTAL_PROPERTY" || variant$5 === "RENTAL_NEED" ? "RENTAL" : "FOR_SALE";
  var match$11 = preference.VAL;
  var variant$6 = preference.NAME;
  var match$12 = preference.VAL;
  var variant$7 = preference.NAME;
  var variant$8 = preference.NAME;
  var tmp$4;
  if (variant$8 === "RENTAL_PROPERTY" || variant$8 === "FOR_SALE_PROPERTY") {
    var match$13 = preference.VAL;
    tmp$4 = match$13 !== undefined ? Core__Option.isSome(match$13.propertyTypes) : false;
  } else {
    var match$14 = preference.VAL;
    tmp$4 = match$14 !== undefined ? Core__Option.isSome(match$14.propertyTypes) : false;
  }
  var tmp$5;
  var exit = 0;
  var propertyTypes;
  var variant$9 = preference.NAME;
  if (variant$9 === "RENTAL_PROPERTY" || variant$9 === "FOR_SALE_PROPERTY") {
    var match$15 = preference.VAL;
    if (match$15 !== undefined) {
      propertyTypes = match$15.propertyTypes;
      exit = 1;
    } else {
      tmp$5 = [];
    }
  } else {
    var match$16 = preference.VAL;
    if (match$16 !== undefined) {
      propertyTypes = match$16.propertyTypes;
      exit = 1;
    } else {
      tmp$5 = [];
    }
  }
  if (exit === 1) {
    tmp$5 = Core__Array.filterMap(Core__Option.getOr(propertyTypes, []), (function (v) {
            return forSalePropertyTypeEnumV5_decode(v);
          }));
  }
  var variant$10 = preference.NAME;
  var tmp$6;
  if (variant$10 === "RENTAL_PROPERTY" || variant$10 === "FOR_SALE_PROPERTY") {
    var match$17 = preference.VAL;
    tmp$6 = match$17 !== undefined ? Core__Option.getOr(Core__Option.flatMap(match$17.mlsStatus, propertyNotificationPreferenceMLSStatus_decode), "ANY") : "ANY";
  } else {
    tmp$6 = "ANY";
  }
  var tmp$7;
  if (currentAreaGroup !== undefined) {
    switch (currentAreaGroup.__typename) {
      case "ChapterAreaGroup" :
          tmp$7 = {
            TAG: "ChapterAreaGroup",
            id: currentAreaGroup.id,
            areas: Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(currentAreaGroup.areas, [])), (function (a) {
                    return Core__Option.map(areaTypeV5_decode(a.type_), (function (t) {
                                  return {
                                          id: a.id,
                                          label: a.label,
                                          type_: t
                                        };
                                }));
                  }))
          };
          break;
      case "UserAreaGroup" :
          tmp$7 = {
            TAG: "UserAreaGroup",
            id: currentAreaGroup.id,
            areas: Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(currentAreaGroup.areas, [])), (function (a) {
                    return Core__Option.map(areaTypeV5_decode(a.type_), (function (t) {
                                  return {
                                          id: a.id,
                                          label: a.label,
                                          type_: t
                                        };
                                }));
                  })),
            usedFor: Core__Array.filterMap(Core__Option.getOr(currentAreaGroup.usedFor, []), (function (v) {
                    return matchableEntityType_decode(v);
                  }))
          };
          break;
      case "__unselected" :
          tmp$7 = RescriptCore.panic("Did not expect there to be no existing area group.");
          break;
      
    }
  } else {
    switch (chapterDefaultAreaGroup.__typename) {
      case "ChapterAreaGroup" :
          tmp$7 = {
            TAG: "ChapterAreaGroup",
            id: chapterDefaultAreaGroup.id,
            areas: Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(chapterDefaultAreaGroup.areas, [])), (function (a) {
                    return Core__Option.map(areaTypeV5_decode(a.type_), (function (t) {
                                  return {
                                          id: a.id,
                                          label: a.label,
                                          type_: t
                                        };
                                }));
                  }))
          };
          break;
      case "UserAreaGroup" :
          tmp$7 = {
            TAG: "UserAreaGroup",
            id: chapterDefaultAreaGroup.id,
            areas: Core__Array.filterMap(Core__Array.keepSome(Core__Option.getOr(chapterDefaultAreaGroup.areas, [])), (function (a) {
                    return Core__Option.map(areaTypeV5_decode(a.type_), (function (t) {
                                  return {
                                          id: a.id,
                                          label: a.label,
                                          type_: t
                                        };
                                }));
                  })),
            usedFor: Core__Array.filterMap(Core__Option.getOr(chapterDefaultAreaGroup.usedFor, []), (function (v) {
                    return matchableEntityType_decode(v);
                  }))
          };
          break;
      case "__unselected" :
          tmp$7 = RescriptCore.panic("Did not expect there to be no existing area group.");
          break;
      
    }
  }
  var form = useForm({
        minPriceToggle: match$11 !== undefined ? Core__Option.isSome(match$11.minPrice) : false,
        minPrice: variant$6 === "RENTAL_PROPERTY" || variant$6 === "FOR_SALE_PROPERTY" ? Core__Option.flatMap(preference.VAL, (function (x) {
                  return x.minPrice;
                })) : Core__Option.flatMap(preference.VAL, (function (x) {
                  return x.minPrice;
                })),
        maxPriceToggle: match$12 !== undefined ? Core__Option.isSome(match$12.maxPrice) : false,
        maxPrice: variant$7 === "RENTAL_PROPERTY" || variant$7 === "FOR_SALE_PROPERTY" ? Core__Option.flatMap(preference.VAL, (function (x) {
                  return x.maxPrice;
                })) : Core__Option.flatMap(preference.VAL, (function (x) {
                  return x.maxPrice;
                })),
        propertyTypesToggle: tmp$4,
        propertyTypes: tmp$5,
        mlsStatus: tmp$6,
        areaGroup: tmp$7
      }, {
        tanType: tanType
      }, (function (output, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var notifyOnSuccess = param.notifyOnSuccess;
          var minPrice = output.minPriceToggle ? output.minPrice : undefined;
          var maxPrice = output.maxPriceToggle ? output.maxPrice : undefined;
          var propertyTypes = output.propertyTypesToggle ? output.propertyTypes : undefined;
          var mlsStatus = output.mlsStatus;
          var match = output.areaGroup;
          var areas;
          var exit = 0;
          var areas$1;
          switch (match.TAG) {
            case "UserAreaGroup" :
            case "ChapterAreaGroup" :
                areas$1 = match.areas;
                exit = 1;
                break;
            case "NewAreaGroup" :
                areas$1 = match.areas;
                exit = 1;
                break;
            
          }
          if (exit === 1) {
            areas = areas$1.map(function (a) {
                  return {
                          areaId: a.id
                        };
                });
          }
          var match$1 = output.areaGroup;
          var areaGroup;
          switch (match$1.TAG) {
            case "UserAreaGroup" :
                areaGroup = {
                  __$inputUnion: "userAreaGroup",
                  _0: {
                    areas: areas,
                    id: match$1.id
                  }
                };
                break;
            case "ChapterAreaGroup" :
                areaGroup = {
                  __$inputUnion: "chapterDefault",
                  _0: true
                };
                break;
            case "NewAreaGroup" :
                areaGroup = {
                  __$inputUnion: "newUserAreaGroup",
                  _0: {
                    areas: areas
                  }
                };
                break;
            
          }
          var tmp;
          switch (preferenceType) {
            case "BUYER_NEED" :
                tmp = {
                  __$inputUnion: "buyerNeeds",
                  _0: {
                    areaGroup: areaGroup,
                    maxPrice: maxPrice,
                    minPrice: minPrice,
                    propertyTypes: propertyTypes
                  }
                };
                break;
            case "FOR_SALE_PROPERTY" :
                tmp = {
                  __$inputUnion: "property",
                  _0: {
                    areaGroup: areaGroup,
                    maxPrice: maxPrice,
                    minPrice: minPrice,
                    mlsStatus: mlsStatus,
                    propertyTypes: propertyTypes
                  }
                };
                break;
            case "RENTAL_NEED" :
                tmp = {
                  __$inputUnion: "rentalNeeds",
                  _0: {
                    areaGroup: areaGroup,
                    maxPrice: maxPrice,
                    minPrice: minPrice,
                    propertyTypes: propertyTypes
                  }
                };
                break;
            case "RENTAL_PROPERTY" :
                tmp = {
                  __$inputUnion: "rentalProperty",
                  _0: {
                    areaGroup: areaGroup,
                    maxPrice: maxPrice,
                    minPrice: minPrice,
                    mlsStatus: mlsStatus,
                    propertyTypes: propertyTypes
                  }
                };
                break;
            
          }
          updatePreference({
                input: tmp
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var updateUserNotificationPreferenceV5 = param.updateUserNotificationPreferenceV5;
                  if (updateUserNotificationPreferenceV5 !== undefined && updateUserNotificationPreferenceV5.__typename === "UserNotificationPreferenceWasUpdated") {
                    notifyOnSuccess(undefined);
                    handleSuccess();
                    return onClose();
                  }
                  notifyOnFailure();
                  handleFailure();
                  onClose();
                }), undefined, undefined);
        }));
  var match$18 = React.useState(function () {
        return form.input;
      });
  var initialFormState = match$18[0];
  var title = "Edit " + NotificationSettingsUtils.toDisplayStringSingular(preferenceType) + " filters";
  var match$19 = React.useState(function () {
        return false;
      });
  var setConfirmDiscardDialogIsOpen = match$19[1];
  var match$20 = React.useState(function () {
        return false;
      });
  var setUserHasMadeChanges = match$20[1];
  var userHasMadeChanges = match$20[0];
  var onCloseEditingDialog = function () {
    if (userHasMadeChanges) {
      return setConfirmDiscardDialogIsOpen(function (param) {
                  return true;
                });
    } else {
      return onClose();
    }
  };
  React.useEffect((function () {
          setUserHasMadeChanges(function (param) {
                return Caml_obj.notequal(initialFormState, form.input);
              });
        }), [form.input]);
  var selectablePropertyTypes = tanType === "RENTAL" ? [
      "SINGLE_FAMILY",
      "CONDO"
    ] : [
      "SINGLE_FAMILY",
      "MULTI_UNIT",
      "CONDO",
      "LOT"
    ];
  var isMobile = MediaQuery.isMobile();
  var match$21 = form.input;
  var hasAtLeastOneCustomFilter;
  if (match$21.maxPriceToggle || match$21.propertyTypesToggle) {
    hasAtLeastOneCustomFilter = true;
  } else {
    switch (match$21.areaGroup.TAG) {
      case "ChapterAreaGroup" :
          hasAtLeastOneCustomFilter = match$21.mlsStatus === "ANY" && !match$21.minPriceToggle ? false : true;
          break;
      case "UserAreaGroup" :
      case "NewAreaGroup" :
          hasAtLeastOneCustomFilter = true;
          break;
      
    }
  }
  var variant$11 = preference.NAME;
  var minPrice = form.input.minPrice;
  var match$22 = form.minPriceResult;
  var tmp$8;
  tmp$8 = match$22 !== undefined ? (
      match$22.TAG === "Ok" ? (
          match$22._0 !== undefined ? ({
                TAG: "Ok",
                _0: "Valid"
              }) : ({
                TAG: "Ok",
                _0: "NoValue"
              })
        ) : ({
            TAG: "Error",
            _0: match$22._0
          })
    ) : undefined;
  var maxPrice = form.input.maxPrice;
  var match$23 = form.maxPriceResult;
  var tmp$9;
  tmp$9 = match$23 !== undefined ? (
      match$23.TAG === "Ok" ? (
          match$23._0 !== undefined ? ({
                TAG: "Ok",
                _0: "Valid"
              }) : ({
                TAG: "Ok",
                _0: "NoValue"
              })
        ) : ({
            TAG: "Error",
            _0: match$23._0
          })
    ) : undefined;
  var variant$12 = preference.NAME;
  return JsxRuntime.jsx(DialogV5.make, {
              title: title,
              isOpen: props.isOpen,
              ariaLabel: title,
              onDismiss: onCloseEditingDialog,
              size: "XXLarge",
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog, {
                            isOpen: match$19[0],
                            onKeepChanges: (function () {
                                setConfirmDiscardDialogIsOpen(function (param) {
                                      return false;
                                    });
                              }),
                            onDiscardChanges: (function () {
                                setConfirmDiscardDialogIsOpen(function (param) {
                                      return false;
                                    });
                                onClose();
                              })
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Turn filters on to customize which " + (
                                      variant$11 === "FOR_SALE_PROPERTY" ? "property" : (
                                          variant$11 === "RENTAL_NEED" ? "rental need" : (
                                              variant$11 === "RENTAL_PROPERTY" ? "rental property" : "buyer need"
                                            )
                                        )
                                    ) + " emails you receive",
                                    className: "mb-4"
                                  }),
                              JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
                                    isOpen: form.input.minPriceToggle,
                                    title: "Minimum Price",
                                    children: JsxRuntime.jsx(Form__Components.TextInputField.make, {
                                          value: minPrice !== undefined ? Numeral.formatNumber(minPrice) : "",
                                          onBlur: (function (param) {
                                              form.blurMinPrice();
                                            }),
                                          onChange: (function (e) {
                                              e.preventDefault();
                                              var value = Core__Int.fromString(Form__Helpers.stripNonDigits(e.target.value), undefined);
                                              form.updateMinPrice((function (v, value) {
                                                      return {
                                                              minPriceToggle: v.minPriceToggle,
                                                              minPrice: value,
                                                              maxPriceToggle: v.maxPriceToggle,
                                                              maxPrice: v.maxPrice,
                                                              propertyTypesToggle: v.propertyTypesToggle,
                                                              propertyTypes: v.propertyTypes,
                                                              mlsStatus: v.mlsStatus,
                                                              areaGroup: v.areaGroup
                                                            };
                                                    }), value);
                                            }),
                                          validationResult: tmp$8,
                                          prepend: "$"
                                        }),
                                    onUpdate: (function (f) {
                                        form.updateMinPriceToggle((function (input, v) {
                                                return {
                                                        minPriceToggle: v,
                                                        minPrice: input.minPrice,
                                                        maxPriceToggle: input.maxPriceToggle,
                                                        maxPrice: input.maxPrice,
                                                        propertyTypesToggle: input.propertyTypesToggle,
                                                        propertyTypes: input.propertyTypes,
                                                        mlsStatus: input.mlsStatus,
                                                        areaGroup: input.areaGroup
                                                      };
                                              }), f);
                                      })
                                  }),
                              JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
                                    isOpen: form.input.maxPriceToggle,
                                    title: "Maximum Price",
                                    children: JsxRuntime.jsx(Form__Components.TextInputField.make, {
                                          value: maxPrice !== undefined ? Numeral.formatNumber(maxPrice) : "",
                                          onBlur: (function (param) {
                                              form.blurMaxPrice();
                                            }),
                                          onChange: (function (e) {
                                              e.preventDefault();
                                              var value = Core__Int.fromString(Form__Helpers.stripNonDigits(e.target.value), undefined);
                                              form.updateMaxPrice((function (v, value) {
                                                      return {
                                                              minPriceToggle: v.minPriceToggle,
                                                              minPrice: v.minPrice,
                                                              maxPriceToggle: v.maxPriceToggle,
                                                              maxPrice: value,
                                                              propertyTypesToggle: v.propertyTypesToggle,
                                                              propertyTypes: v.propertyTypes,
                                                              mlsStatus: v.mlsStatus,
                                                              areaGroup: v.areaGroup
                                                            };
                                                    }), value);
                                            }),
                                          validationResult: tmp$9,
                                          prepend: "$"
                                        }),
                                    onUpdate: (function (f) {
                                        form.updateMinPriceToggle((function (input, v) {
                                                return {
                                                        minPriceToggle: input.minPriceToggle,
                                                        minPrice: input.minPrice,
                                                        maxPriceToggle: v,
                                                        maxPrice: input.maxPrice,
                                                        propertyTypesToggle: input.propertyTypesToggle,
                                                        propertyTypes: input.propertyTypes,
                                                        mlsStatus: input.mlsStatus,
                                                        areaGroup: input.areaGroup
                                                      };
                                              }), f);
                                      })
                                  }),
                              JsxRuntime.jsxs(NotificationSettingsPreferenceEditDialog$CheckSection, {
                                    isOpen: form.input.propertyTypesToggle,
                                    title: "Property Types",
                                    children: [
                                      JsxRuntime.jsx(TogglesGroup.make, {
                                            children: selectablePropertyTypes.map(function (ptype) {
                                                  var checked = form.input.propertyTypes.includes(ptype);
                                                  var label;
                                                  switch (ptype) {
                                                    case "CONDO" :
                                                        label = "Condo/Townhouse";
                                                        break;
                                                    case "LOT" :
                                                        label = "Lot";
                                                        break;
                                                    case "MULTI_UNIT" :
                                                        label = "Multi unit";
                                                        break;
                                                    case "SINGLE_FAMILY" :
                                                        label = "Single family";
                                                        break;
                                                    
                                                  }
                                                  return JsxRuntime.jsx(Form__Checkbox.make, {
                                                              onChange: (function (param) {
                                                                  form.updatePropertyTypes((function (input, propertyTypes) {
                                                                          return {
                                                                                  minPriceToggle: input.minPriceToggle,
                                                                                  minPrice: input.minPrice,
                                                                                  maxPriceToggle: input.maxPriceToggle,
                                                                                  maxPrice: input.maxPrice,
                                                                                  propertyTypesToggle: input.propertyTypesToggle,
                                                                                  propertyTypes: propertyTypes,
                                                                                  mlsStatus: input.mlsStatus,
                                                                                  areaGroup: input.areaGroup
                                                                                };
                                                                        }), checked ? form.input.propertyTypes.filter(function (v) {
                                                                              return v !== ptype;
                                                                            }) : Belt_Array.concatMany([
                                                                              form.input.propertyTypes,
                                                                              [ptype]
                                                                            ]));
                                                                }),
                                                              checked: checked,
                                                              label: label,
                                                              mobileStyles: true
                                                            }, label);
                                                })
                                          }),
                                      JsxRuntime.jsx(Form__Components.FieldErrorV2.make, {
                                            valid: form.propertyTypesResult
                                          })
                                    ],
                                    onUpdate: (function (f) {
                                        form.updatePropertyTypesToggle((function (input, v) {
                                                return {
                                                        minPriceToggle: input.minPriceToggle,
                                                        minPrice: input.minPrice,
                                                        maxPriceToggle: input.maxPriceToggle,
                                                        maxPrice: input.maxPrice,
                                                        propertyTypesToggle: v,
                                                        propertyTypes: input.propertyTypes,
                                                        mlsStatus: input.mlsStatus,
                                                        areaGroup: input.areaGroup
                                                      };
                                              }), f);
                                      })
                                  }),
                              variant$12 === "RENTAL_PROPERTY" || variant$12 === "FOR_SALE_PROPERTY" ? JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
                                      isOpen: form.input.mlsStatus === "NOT_ACTIVE_ON_MLS",
                                      title: isMobile ? "Not active on the MLS" : "Only " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + " not currently active on the MLS"),
                                      children: null,
                                      onUpdate: (function (value) {
                                          form.updateMlsStatus((function (input, v) {
                                                  return {
                                                          minPriceToggle: input.minPriceToggle,
                                                          minPrice: input.minPrice,
                                                          maxPriceToggle: input.maxPriceToggle,
                                                          maxPrice: input.maxPrice,
                                                          propertyTypesToggle: input.propertyTypesToggle,
                                                          propertyTypes: input.propertyTypes,
                                                          mlsStatus: v,
                                                          areaGroup: input.areaGroup
                                                        };
                                                }), value ? "NOT_ACTIVE_ON_MLS" : "ANY");
                                        }),
                                      helpText: "You will not receive broadcasts about " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + " that are currently active on the MLS")
                                    }) : null
                            ],
                            className: ""
                          }),
                      JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups.make, {
                            chapter: chapter.fragmentRefs,
                            settings: settings.fragmentRefs,
                            currentAreaGroup: form.input.areaGroup,
                            setAreaGroup: (function (areaGroup) {
                                form.updateAreaGroup((function (input, areaGroup) {
                                        return {
                                                minPriceToggle: input.minPriceToggle,
                                                minPrice: input.minPrice,
                                                maxPriceToggle: input.maxPriceToggle,
                                                maxPrice: input.maxPrice,
                                                propertyTypesToggle: input.propertyTypesToggle,
                                                propertyTypes: input.propertyTypes,
                                                mlsStatus: input.mlsStatus,
                                                areaGroup: areaGroup
                                              };
                                      }), areaGroup);
                              }),
                            preferenceType: preferenceType,
                            fieldResult: form.areaGroupResult
                          }),
                      !hasAtLeastOneCustomFilter && userHasMadeChanges ? JsxRuntime.jsx(Alert.$$Error.make, {
                              title: "You must select at least one custom filter",
                              className: "shadow-sm"
                            }) : null,
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                                          onClick: (function (param) {
                                              onCloseEditingDialog();
                                            }),
                                          size: "huge",
                                          children: Caml_option.some(userHasMadeChanges ? "Discard Changes" : "Cancel")
                                        }),
                                    className: "mr-16"
                                  }),
                              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                    onClick: (function (e) {
                                        e.preventDefault();
                                        form.submit();
                                      }),
                                    disabled: !userHasMadeChanges || match[1] || form.submitting || !hasAtLeastOneCustomFilter,
                                    size: "large",
                                    children: "Save Changes"
                                  })
                            ],
                            className: "flex flex-row items-baseline justify-end mt-4 p-4"
                          })
                    ],
                    className: "w-full bg-white"
                  })
            });
}

var make = NotificationSettingsPreferenceEditDialog;

exports.CheckSection = CheckSection;
exports.ConfirmDiscardChangesDialog = ConfirmDiscardChangesDialog;
exports.FormConfig = FormConfig;
exports.UpdateUserNotificationPreferenceV5Mutation = UpdateUserNotificationPreferenceV5Mutation;
exports.PreferenceFragment = PreferenceFragment;
exports.ClientNeedFragment = ClientNeedFragment;
exports.AreaGroupFragment = AreaGroupFragment;
exports.ChapterFragment = ChapterFragment;
exports.SettingsFragment = SettingsFragment;
exports.make = make;
/* commitMutation Not a pure module */
